module.exports = __webpack_public_path__ + "static/img/包裝第一組組長-陳文選.e692006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第一組組長-陳文選.jpg
// module id = /f1c
// module chunks = 1